import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { ExpertContext } from "../../data/expert_context_management";
import useExpertRepresentationsApi from "../../data/use_expert_representations_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
// The picker (a paginated async product search + Add button) is plain chrome driven entirely by its
// props, so this page mounts the same one the PR engine's own Products modal is built around, rather
// than forking it — the identical cross-engine relationship this file's Experts sibling already has
// with AddExpertInput.
import AddProductInput from "../../../pr_profiles/edit/products_modal_body/add_product_card/AddProductInput";

// The Add surface for represented products. Only the picker lives here: removal happens inline on the
// section itself (every tab), so this body deliberately does not restate the represented list.
//
// Reads the collection + plumbing straight from ExpertContext (the provider owns them — no modal-local
// fetch) and writes via use_expert_representations_api. Mirrors ExpertsModalBody exactly, entity
// swapped: the picker mounts directly (no passive "+" tile), and a successful add auto-closes the
// modal, same as the Experts body.
function ProductsModalBody({ close }) {
  const context = useContext(ExpertContext);
  const { alsoRepresents, generalError, setActiveTabRequest } = context;
  const { addRepresentation } = useExpertRepresentationsApi(context);

  // Products (and companies) are never self-represented — Id::Representation's self_expert semantics
  // apply only to experts — so unlike the Experts picker, there is no self id to add to the exclusion
  // set here, only the products already represented.
  const excludedProductIds = (alsoRepresents || [])
    .filter((entity) => entity.promotedEntityType === "Id::PromoEntity::Product")
    .map((entity) => entity.promotedEntityId);

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} />
        <div className="row g-2">
          <AddProductInput
            existingProductsIds={excludedProductIds}
            onSubmit={async (productId) => {
              // Stay open on failure so the alert above is what the viewer sees, not a vanished modal.
              const { saved } = await addRepresentation(productId);
              if (saved) {
                setActiveTabRequest("products");
                close();
              }
            }}
            onCancel={close}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ProductsModalBody;
